export default __webpack_public_path__ + "static/media/white-pawn.ed2a4ef5.png";